import { type TFunction } from 'i18next';
import { allowedCountries } from '@/data/allowedCountries';
import { supportedVatCountries, vatFunctions } from '@/data/vatDefinitions';

export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,7}$/;
export const phoneNumberRegExp = /^\+[0-9]{1,5}[0-9]+$/;
export const phoneNumberOptionalRegExp = /^\+[0-9]{1,3}$/;
export const phoneNumberOnlyNumbersRegExp = /(?<!^)\+|[^\d+]/g;

export const isValidEmail = (
  email: string | undefined | null,
  required = false
) => {
  return emailRegExp.test(email ?? '') || (!required && !email);
};

export const isValidVat = (vat: string, countryISO: string) => {
  if (!allowedCountries[countryISO] || !supportedVatCountries[countryISO]) {
    return false;
  }

  if (vatFunctions[countryISO]) {
    return vatFunctions[countryISO](vat);
  }

  if (supportedVatCountries[countryISO].regex) {
    const vatRegex = new RegExp(supportedVatCountries[countryISO].regex);
    return vatRegex.test(vat);
  }
  return true;
};

export const getPasswordRules = (t: TFunction<string[], undefined>) => {
  return {
    required: t?.('auth:passwordRules.isMandatory') ?? true,
    validate: {
      hasLength: (value: string) =>
        (value.length >= 8 && value.length < 33) ||
        (t?.('auth:passwordRules.hasLength') ?? false),
      hasUpperAndLowerCase: (value: string) =>
        /[A-Z]/.test(value) ||
        (t?.('auth:passwordRules.hasUpperAndLowerCase') ?? false),
      hasNumber: (value: string) =>
        /\d/.test(value) || (t?.('auth:passwordRules.hasNumber') ?? false),
      hasSymbol: (value: string) =>
        /[^A-Za-z0-9]/.test(value) ||
        (t?.('auth:passwordRules.hasSymbol') ?? false),
    },
  };
};

export const getPasswordMatch = (
  t: TFunction<string[], undefined>,
  compare: string
) => {
  return {
    required: t?.('auth:passwordRules.isMandatory') ?? true,
    validate: {
      mustMatch: (value: string) =>
        (value.length > 0 && value === compare) ||
        (t?.('auth:passwordRules.mustMatch') ?? false),
    },
  };
};
